import React, { Suspense, useState } from 'react';

// Loaded on demand: the billing modal pulls in the payment services.
const UpgradeModal = React.lazy(() => import('../BillingModal').then((module) => ({ default: module.UpgradeModal })));

/** Upgrade on a gate that is not about credits (the hourly quota queue): opens the plans. */
export const GateUpgradeButton: React.FC<{ onRecord: () => void; label?: string }> = ({ onRecord, label = 'Upgrade' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="ai-overview-action-btn ai-overview-action-btn--upgrade system-msg-review-btn system-msg-review-btn--upgrade"
        onClick={() => { onRecord(); setOpen(true); }}
        type="button"
      >
        <i className="fa-solid fa-arrow-up" aria-hidden="true" /> {label}
      </button>
      {open && <Suspense fallback={null}><UpgradeModal onClose={() => setOpen(false)} /></Suspense>}
    </>
  );
};
